import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const QR_DARK = '#0f1b2d';

export async function createQrDataUrl(text: string, size: number): Promise<string> {
  return QRCode.toDataURL(text, {
    width: size,
    margin: 2,
    errorCorrectionLevel: 'M',
    color: { dark: QR_DARK, light: '#ffffff' },
  });
}

interface InstallQrCodeProps {
  value: string;
  size?: number;
  className?: string;
}

export default function InstallQrCode({ value, size = 240, className = '' }: InstallQrCodeProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setFailed(false);
    createQrDataUrl(value, size * 2)
      .then((url) => { if (active) setDataUrl(url); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [value, size]);

  if (failed) {
    return (
      <div style={{ width: size, height: size }} className={`flex items-center justify-center rounded-2xl bg-gray-50 p-4 text-center text-xs text-gray-500 ${className}`}>
        Não foi possível gerar o QR Code. Use o link abaixo.
      </div>
    );
  }

  if (!dataUrl) {
    return <div style={{ width: size, height: size }} className={`animate-pulse rounded-2xl bg-gray-100 ${className}`} />;
  }

  return (
    <img
      src={dataUrl}
      width={size}
      height={size}
      alt="QR Code para instalar o app Cifrão"
      className={`rounded-2xl ${className}`}
    />
  );
}
